import { gql, TypedDocumentNode } from "@apollo/client";

import { IntentProject, IntentProjectSearchIntentResourcesOperationsArgs } from "types/generated";

export const SEARCH_INTENT_RESOURCES_OPERATIONS: TypedDocumentNode<
  { intentProject: Pick<IntentProject, "id" | "searchIntentResourcesOperations"> },
  { intentProjectId: string } & IntentProjectSearchIntentResourcesOperationsArgs
> = gql`
  query SearchIntentResourcesOperations($intentProjectId: ID!, $input: SearchInput!) {
    intentProject(id: $intentProjectId) {
      id
      searchIntentResourcesOperations(input: $input) {
        edges {
          cursor
          node {
            allow
            deny
            id
            author
            createdAt
            operation
            provider
            resourceID
            resourceType
            state
            currentState
            proposedState
            failed
          }
        }
        pageInfo {
          hasNextPage
          endCursor
          startCursor
        }
      }
    }
  }
`;
